import { Component, Input, OnInit } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { takeUntil } from 'rxjs';
import { ACADEMIC_PROGRESS } from '../../../../config/academic_progress';
import { getDateInFormat } from '../../../../config/video-tutorial-data';
import { ClearObservableHelper } from '../../../../helpers/ClearObservableHelper';
import { User } from '../../../../interface/user';
import { GoogleAnalyticsService } from '../../../../services/google-analytics.service';
import { StorageService } from '../../../../services/storage.service';
@Component({
  selector: 'ngx-performance-usage-chart',
  template: `
    <div *ngIf="!isShow">
      <h6 class="quicksand-bold-label text-center mt-5">
        Please try again after some time!
      </h6>
    </div>
    <div *ngIf="isShow">
      <div
        echarts
        [options]="countryCasesChartOptions"
        class="demo-chart"
      ></div>
    </div>
  `,
  styleUrls: ['./performance-usage-chart.component.scss'],
})
export class PerformanceUsageChartComponent extends ClearObservableHelper implements OnInit {
  selectedCountry: string;
  countryCasesChartOptions: any;
  cases = [];
  colors = ['#AC9BF5', '#5984C2'];
  @Input() currentUser: User;
  @Input() currentTheme: string;
  isMock = this.storageService.getItem('user').user['is_trial_user'] ? true : false;
  isShow = false;
  currentSchoolCalendar: any;

  constructor(
    private googleAnalytics: GoogleAnalyticsService,
    private storageService: StorageService,
    private themeService: NbThemeService,
  ) {
    super();
  }

  async ngOnInit() {
    try {
      this.currentSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
      // Listen for changes to the selected school  and update chart data accordingly
      this.storageService.setSelectedSchoolsToLocalStorage.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
        if (res) {
          this.currentSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
          this.getData();
        }
      });

      /**
       * Listen for school calendar changes and refresh chart data accordingly
       */
      this.storageService.setSelectedSchoolsCalendarToLocalStorage
        .pipe(takeUntil(this.destroy$))
        .subscribe(async (res) => {
          if (res) {
            this.currentSchoolCalendar = res;
            this.getData();
          }
        });

      this.themeService.onThemeChange().subscribe((res) => {
        this.currentTheme = res?.name;
        this.setOptions();
      });
      this.getData();
    } catch (error) {
      // console.log(error);
    }
  }

  async getData() {
    try {
      const token: any = await this.googleAnalytics.getToken();
      if (token?.access_token) {
        this.isShow = true;
        this.storageService.setItem('access_type', token?.access_token);
        await this.getMonthsData();
      } else {
        this.isShow = false;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async divideMonths(startDate, endDate) {
    try {
      const months = [];
      const start = new Date(startDate);
      const finalDate = new Date(endDate);

      // Validate dates
      if (isNaN(start.getTime()) || isNaN(finalDate.getTime()) || start > finalDate) {
        return months;
      }

      for (
        const currentDate = new Date(start.getFullYear(), start.getMonth(), 1);
        currentDate <= finalDate && months.length < 36;
        currentDate.setFullYear(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
      ) {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;

        const firstDayOfMonth = new Date(year, month - 1, 1);
        const lastDayOfMonth = new Date(year, month, 0);

        months.push({
          startDate: firstDayOfMonth,
          endDate: lastDayOfMonth,
        });
      }

      return months;
    } catch (error) {
      console.log('PerformanceUsageChartComponent ~ divideMonths ~ error:', error);
      return [];
    }
  }

  combineArrays(arr1, arr2) {
    const result = [];
    if (arr1.length !== arr2.length) {
      throw new Error('Arrays must have the same length');
    }
    for (let i = 0; i < arr1.length; i++) {
      result.push({
        date: arr1[i].startDate,
        value: this.isMock ? ACADEMIC_PROGRESS[i] : arr2[i],
      });
    }
    return result;
  }

  async getMonthsData() {
    try {
      const dividedMonthsValues = await this.divideMonths(
        new Date(this.currentSchoolCalendar?.start),
        new Date(this.currentSchoolCalendar?.end),
      );
      const promises = dividedMonthsValues.map((month) =>
        this.googleAnalytics.getAnalyticsData(getDateInFormat(month.startDate), getDateInFormat(month.endDate)),
      );
      Promise.all(promises)
        .then((results) => {
          this.cases = this.combineArrays(dividedMonthsValues, results);
          this.setOptions();
        })
        .catch((error) => {
          console.error('getMonthsData', error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  // setOptions() {
  //   try {
  //     this.countryCasesChartOptions = {
  //       grid: {
  //         left: 40,
  //         top: 30,
  //         right: 0,
  //         bottom: 40,
  //       },
  //       tooltip: {
  //         trigger: 'item',
  //         axisPointer: {
  //           type: 'line',
  //           lineStyle: {
  //             color: '#FF5733',
  //             width: 2,
  //           },
  //         },
  //         textStyle: {
  //           color: '#333',
  //           fontSize: 14,
  //           fontWeight: 'bold',
  //         },
  //         position: 'top',
  //         backgroundColor: '#F0F0F0',
  //         borderColor: '#999',
  //         borderWidth: 1,
  //         formatter: (params) => {
  //           return Math.round(parseInt(params.value, 10));
  //         },
  //         extraCssText: 'box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);',
  //       },

  //       legend: {
  //         padding: [0, 0, 20, 0],
  //         itemGap: 20,
  //         data: [
  //           {
  //             name: 'Active Users',
  //             icon: 'square',
  //             itemStyle: {
  //               width: 5,
  //               type: 'solid',
  //               color: 'green',
  //             },
  //             textStyle: {
  //               color:
  //                 this.currentTheme === 'material-dark' ? '#d1d5d8' : '#424242',
  //             },
  //           },
  //           {
  //             name: 'New Users',
  //             icon: 'square',
  //             itemStyle: {
  //               width: 5,
  //               type: 'solid',
  //               color: 'purple',
  //             },
  //             textStyle: {
  //               color:
  //                 this.currentTheme === 'material-dark' ? '#d1d5d8' : '#424242',
  //             },
  //           },
  //         ],
  //       },

  //       xAxis: {
  //         type: 'category',
  //         boundaryGap: false,
  //         offset: 5,
  //         data: this.cases.map((c) => new Date(c.date).toLocaleDateString()),
  //         axisTick: {
  //           show: false,
  //         },
  //         axisLabel: {
  //           color: '#828282',
  //           fontSize: 16,
  //         },
  //         axisLine: {
  //           lineStyle: {
  //             color: '#A3A3A3',
  //             width: 1,
  //           },
  //         },
  //       },
  //       yAxis: {
  //         type: 'value',
  //         max: 200,
  //         interval: 40,
  //         boundaryGap: false,
  //         axisLine: {
  //           show: true,
  //           lineStyle: {
  //             color: '#A3A3A3',
  //             width: 1,
  //           },
  //         },
  //         axisLabel: {
  //           color: '#828282',
  //           fontSize: 18,
  //         },
  //         axisTick: {
  //           show: false,
  //         },
  //         splitLine: {
  //           lineStyle: {
  //             color: '#f5f5f5',
  //           },
  //         },
  //       },
  //       series: [
  //         {
  //           name: 'Active Users',
  //           type: 'line',
  //           smooth: true,
  //           symbolSize: 20,
  //           itemStyle: {
  //             normal: {
  //               opacity: 0,
  //             },
  //             emphasis: {
  //               opacity: 0,
  //             },
  //           },
  //           lineStyle: {
  //             normal: {
  //               width: 3,
  //               type: 'solid',
  //               color: '#81C541',
  //             },
  //             opacity: 0.6,
  //           },
  //           areaStyle: {
  //             normal: {
  //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 {
  //                   offset: 0,
  //                   color: '#DFFAF1',
  //                 },
  //                 {
  //                   offset: 1,
  //                   color: '#DCE6E9',
  //                 },
  //               ]),
  //               opacity: 1,
  //             },
  //           },
  //           data: this.cases.map((c) =>
  //             c.value.hasOwnProperty('rows')
  //               ? Number(c.value.rows[0].metricValues[0].value)
  //               : 0
  //           ),
  //         },
  //         {
  //           name: 'New Users',
  //           type: 'line',
  //           smooth: true,
  //           symbolSize: 20,
  //           itemStyle: {
  //             normal: {
  //               opacity: 0,
  //             },
  //             emphasis: {
  //               color: '#ffffff',
  //               borderColor: '#333',
  //               borderWidth: 3,
  //             },
  //           },
  //           lineStyle: {
  //             normal: {
  //               width: 2,
  //               type: 'solid',
  //               color: '#6200EE',
  //             },
  //             opacity: 0.6,
  //           },
  //           areaStyle: {
  //             normal: {
  //               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //                 {
  //                   offset: 0,
  //                   color: '#E4EBFF',
  //                 },
  //                 {
  //                   offset: 1,
  //                   color: '#E5E8EA',
  //                 },
  //               ]),
  //             },
  //           },
  //           data: this.cases.map((c) =>
  //             c.value.hasOwnProperty('rows')
  //               ? Number(c.value.rows[0].metricValues[1].value)
  //               : 0
  //           ),
  //         },
  //       ],
  //     };
  //   } catch (error) {
  //     // console.log(error);
  //   }
  // }

  setOptions() {
    try {
      this.countryCasesChartOptions = {
        grid: {
          left: 40,
          top: 30,
          right: 0,
          bottom: 40,
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#FF5733',
              width: 2,
            },
          },
          textStyle: {
            color: '#333',
            fontSize: 14,
            fontWeight: 'bold',
          },
          position: 'top',
          backgroundColor: '#F0F0F0',
          borderColor: '#999',
          borderWidth: 1,
          formatter: (params) => Math.round(parseInt(params.value, 10)),
          extraCssText: 'box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);',
        },

        legend: {
          padding: [0, 0, 20, 0],
          itemGap: 20,
          data: [
            {
              name: 'Active Users',
              icon: 'square',
              itemStyle: {
                width: 5,
                type: 'solid',
                color: 'green',
              },
              textStyle: {
                color: this.currentTheme === 'material-dark' ? '#d1d5d8' : '#424242',
              },
            },
            {
              name: 'New Users',
              icon: 'square',
              itemStyle: {
                width: 5,
                type: 'solid',
                color: 'purple',
              },
              textStyle: {
                color: this.currentTheme === 'material-dark' ? '#d1d5d8' : '#424242',
              },
            },
          ],
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          offset: 5,
          data: this.cases.map((c) => new Date(c.date).toLocaleDateString()),
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#828282',
            fontSize: 16,
          },
          axisLine: {
            lineStyle: {
              color: '#A3A3A3',
              width: 1,
            },
          },
        },
        yAxis: {
          type: 'value',
          max: 200,
          interval: 40,
          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#A3A3A3',
              width: 1,
            },
          },
          axisLabel: {
            color: '#828282',
            fontSize: 18,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5',
            },
          },
        },
        series: [
          {
            name: 'Active Users',
            type: 'line',
            smooth: true,
            symbolSize: 20,
            itemStyle: {
              opacity: 0,
            },
            lineStyle: {
              width: 3,
              color: '#81C541',
              opacity: 0.6,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#DFFAF1' },
                { offset: 1, color: '#DCE6E9' },
              ]),
              opacity: 1,
            },
            data: this.cases.map((c) => (c.value?.rows ? Number(c.value.rows[0].metricValues[0]?.value || 0) : 0)),
          },
          {
            name: 'New Users',
            type: 'line',
            smooth: true,
            symbolSize: 20,
            itemStyle: {
              opacity: 0,
            },
            lineStyle: {
              width: 2,
              color: '#6200EE',
              opacity: 0.6,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#E4EBFF' },
                { offset: 1, color: '#E5E8EA' },
              ]),
            },
            data: this.cases.map((c) => (c.value?.rows ? Number(c.value.rows[0].metricValues[1]?.value || 0) : 0)),
          },
        ],
      };
    } catch (error) {
      console.error('Error setting chart options:', error);
    }
  }
}
